import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TranslationService } from '@services/translation.service';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-input-dropdown',
    templateUrl: './input-dropdown.component.html',
    styleUrls: ['./input-dropdown.component.scss'],
    standalone: false
})
export class InputDropdownComponent implements OnInit {
  @Input() appendTo = 'body';
  @Input() disabled = false;
  @Input() placeholder = this.translation.getTranslatedContent(
    'select',
    'Select'
  );
  @Input() label;
  @Input() control;
  @Input() tooltip;
  @Input() inline = false;
  @Input() shouldBeFullWidth = true;
  @Input() options: { value: any; text: string; disabled?: boolean }[] = [];
  @Input() multipleValues: boolean = false;
  @Input() error: string;
  public control$;
  public isRequired: boolean = false;
  constructor(
    private cdr: ChangeDetectorRef,
    private translation: TranslationService
  ) {}
  ngOnInit(): void {
    if (this.control?.validator) {
      this.isRequired = this.control.validator(
        new UntypedFormControl()
      )?.required;
    }
    this.control$ = this?.control?.statusChanges.pipe(
      tap(() => {
        this.cdr?.detectChanges();
      })
    );
  }
}
